import { Button, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactElement } from 'react';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';

interface ShowMoreButtonProps extends ButtonProps {
  expanded: boolean;
  onToggle: () => void;
}

const StyledShowMoreButton = styled(Button)(({ theme }) => ({
  alignSelf: 'center',
  color: theme.palette.text.secondary,
  textTransform: 'none',
  paddingInline: theme.spacing(1.5),
}));

export const ShowMoreButton = ({
  expanded,
  onToggle,
  children,
  ...buttonProps
}: ShowMoreButtonProps): ReactElement => (
  <StyledShowMoreButton
    variant="text"
    onClick={onToggle}
    endIcon={
      <DynamicIcon
        name="chevron-down"
        library="lucide"
        sx={{
          transition: 'transform 300ms',
          rotate: expanded ? '180deg' : undefined,
        }}
      />
    }
    {...buttonProps}
  >
    {children ?? (expanded ? 'Show Less' : 'Show More')}
  </StyledShowMoreButton>
);
